import { Box } from '@mui/material';
import {
  CheckCircleIcon,
  CircleIcon,
  RadioButtonIcon,
} from '@phosphor-icons/react';

interface ConsentIdentityStepIconProps {
  active?: boolean;
  completed?: boolean;
}

const ConsentIdentityStepIcon = ({
  active,
  completed,
}: ConsentIdentityStepIconProps) => {
  return (
    <Box>
      {!completed && !active && <CircleIcon />}
      {active && <RadioButtonIcon weight="duotone" />}
      {completed && <CheckCircleIcon color="#26ab76" weight="duotone" />}
    </Box>
  );
};

export default ConsentIdentityStepIcon;
